import { defineMessages } from "@formatjs/intl";

export default defineMessages({
  RoomName: {
    id: "InitialCost.RoomName",
    defaultMessage: `ビレッジハウス{name}`,
  },
  RoomNumber: {
    id: "InitialCost.RoomNumber",
    defaultMessage: `{bNo}号棟{rNo}号室`,
  },
});
